import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import Swal from 'sweetalert2';
import { OrganizationSearch } from '../models/organizationsearch'
import { OrgDocuments, TYPE, CLASSIFICATION, OrganizationTab, AccreditationsTab, ProgramStatusTab, QaDetailsTab, Qadetail, QaStats } from '../models/organizationdetail'
import { OrganizationMaintainenceService } from '../services/organization-maintainence.service';
import { ExportUtilService } from '../services/export-util.service'
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDragEnter, CdkDragExit } from '@angular/cdk/drag-drop';
import { MatSnackBar } from "@angular/material/snack-bar";
import { UtilityService } from './../services/utility.service';
import { WaitDialogComponent } from '../util/wait-dialog/wait-dialog.component';
import { DataTransferService } from '../services/data-transfer.service';
import { format } from 'date-fns';
import { Subscription } from 'rxjs';
import { UserService } from '../services/user.service';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-organization-maintenance',
  templateUrl: './organization-maintenance.component.html',
  styleUrls: ['./organization-maintenance.component.scss']
})
export class OrganizationMaintenanceComponent implements OnInit, AfterViewInit {

  constructor(
    private formBuilder: UntypedFormBuilder, 
    private organizationMaintainenceService: OrganizationMaintainenceService,
    private userService: UserService,
    private exportUtilService: ExportUtilService, 
    private snackBar: MatSnackBar, private dataTransfer:DataTransferService,
    private cdr: ChangeDetectorRef,
    private utilityService: UtilityService, private dialog: MatDialog
  ) {}

  //Accreditations Tab
  dataSourceAccreditations = new MatTableDataSource<AccreditationsTab>();
  dataSourceQaDetails = new MatTableDataSource<Qadetail>();
  dataSourceQaStats = new MatTableDataSource<QaStats>();
  displayedColumnsAccreditations: string[] = ['Classification', 'Number', 'Issued', 'Expires', 'State', 'Specialty', 'Edit', 'Delete'];
  displayedColumnsQa: string[] = ['Program','QA Percentage','Edit','Delete'];
  displayedColumsQaStats: string[] = ['Type', 'Required', 'Completed', 'Avg. Score*', 'Failures*'];
  addAccred: boolean = false;
  editAccred: boolean =false;

  addQa: boolean = false;
  editQa: boolean = false;

  addOrEditText: string;
  newAccreditation: any;
  oldAccreditation: any;
  isLegacy : boolean = false;
  readonlyOrgCD : boolean = false;
  formAccredGroup: UntypedFormGroup;
  formQAGroup: UntypedFormGroup;
  private subs = new Subscription();
  addonOptions = [{ addonName: "name1", isChecked: false }, { addonName: "name2", isChecked: true }, { addonName: "name3", isChecked: false }, { addonName: 'name4', isChecked: true }]
  selectedOrgForm: UntypedFormGroup;
  @ViewChild('Tabs', { static: true }) organizationMaintenanceTabs: MatTabGroup;
  formGroup: UntypedFormGroup;
  formDetailedGroup: UntypedFormGroup;
  formCheckDetailedGroup: UntypedFormGroup;
  formDocGroup: UntypedFormGroup;
  organizationForm: any;
  organization: OrganizationSearch[] | any = [];
  newOrganization: OrganizationSearch;
  organizationDetails: any;
  displayedColumns: string[] = ['ORGANIZATION_DESC', 'ORGANIZATION_CD', 'CITY', 'PHONE_NUMBER', 'EXTERNALKEY'];
  dataSourceOrganization = new MatTableDataSource<OrganizationSearch>(); // OrganizationalSearch[];
  orgSelection = new SelectionModel<OrganizationSearch>(false, []);
  @ViewChild(MatSort) sort: MatSort;
  organizationSearching: boolean = false;
  displayedDocumentsColumns: string[] = ['TITLE', 'DESCRIPTION', 'LASTUPDATED', 'columnEdit', 'columnView', 'columnDelete']; //, 'ACTIVE'];
  dataSourceDocuments = new MatTableDataSource<OrgDocuments>();
  documentTypeOpt: TYPE[];
  isOrgSelected: boolean = true;
  activeDocuments: boolean = false;
  docSelection = new SelectionModel<OrgDocuments>(true, []);
  typeOpt: TYPE[];
  classificationOpt: CLASSIFICATION[]
  contractors: string[] = [];
  selectedIndex: number = 0;
  organizationContractors: string[] = [];
  selectedOrg: string;
  orgType: boolean;
  addNewOrg: OrganizationTab;
  addZip: string;
  docType: boolean = false;
  isDocUploaded: boolean = false;
  docActionName: string = "Upload New Document"
  addOrgDetails: any;
  contractorPayload: any;
  contractorStatus: boolean = false;
  extractedFileData: any;
  docSavetype: boolean = true;
  fileName: string;
  newOrgSel: boolean = false;
  select_all = false;
  selectAllServiceTypes = false;
  emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  formDetailedStatus: boolean = false;
  formDocStatus: boolean = false;
  hideSave: boolean = false;
  sysImageId: any;
  isPoBox = false;
  isSameAddressChecked = false;
  className = localStorage.getItem("themeName");
  isDocActiveDisabled: boolean = false;
  programStatusTab: ProgramStatusTab;  
  qaDetailsTab: QaDetailsTab;
  questionLookup = [
    { Id: 1, Value: 'Yes' },
    { Id: 0, Value: 'No' }
  ];

  ngOnInit(): void {
    this.dataTransfer.myMethod(true);
    this.createForm();
    this.selectedOrgForm = this.formBuilder.group({
      addons: this.formBuilder.array([])
    });

    this.formDetailedGroup.valueChanges.subscribe(
      result => {
        console.log('result form', result);
        this.formDetailedStatus = true;
      })

    this.formCheckDetailedGroup.valueChanges.subscribe(
      result => {
        console.log('result form', result);
        this.formDetailedStatus = true;
      })

    this.formDocGroup.valueChanges.subscribe(
      result => {
        console.log('result form', result);
        this.formDocStatus = true;
      })

    this.formDetailedGroup.get('LICENSE')?.valueChanges.subscribe(value => {
        if (value) {
          this.formDetailedGroup.get('LICENSEEXP')?.setValidators([Validators.required]);
        } else {
          this.formDetailedGroup.get('LICENSEEXP')?.clearValidators();
        }
        this.formDetailedGroup.get('LICENSEEXP')?.updateValueAndValidity();
      });
      
      const streetNumCtrl = this.formDetailedGroup.get('AS_WR_STREETNUM')!;
      
      this.subs.add(
        streetNumCtrl.valueChanges
        .pipe(startWith(streetNumCtrl.value))
        .subscribe((val: string | null) => {
          // Only auto-detect PO BOX if the user hasn't manually set it via checkbox
          // When checkbox is checked, respect that state regardless of field value
          const shouldBePoBox = this.isPoBoxString(val);
          if (!this.isPoBox && shouldBePoBox) {
            // Only auto-detect if currently not in PO BOX mode and value suggests PO BOX
            this.isPoBox = true;
            this.applyPoBoxState(true);
            this.cdr.markForCheck();
          }
        })
      );

      const streetNameCtrl = this.formDetailedGroup.get('AS_WR_STREETNAME')!;
      this.subs.add(
        streetNameCtrl.valueChanges
        .pipe(startWith(streetNameCtrl.value))
        .subscribe((val: string | null) => {
          this.determinePoBoxValidations(val, streetNumCtrl);
        })
      );

      const payeeStreetNameCtrl = this.formCheckDetailedGroup.get('AS_PAYEE_STREETNAME')!;
      const payeeStreetNumCtrl = this.formCheckDetailedGroup.get('AS_PAYEE_STREETNUM')!;
      this.subs.add(
        payeeStreetNameCtrl.valueChanges
        .pipe(startWith(payeeStreetNameCtrl.value))
        .subscribe((val: string | null) => {
          this.determinePoBoxValidations(val, payeeStreetNumCtrl);
        })
      );
  }

  determinePoBoxValidations (val: string | null, numberControl: AbstractControl): void {
    const isWorkStreetNumberControl = numberControl === this.formDetailedGroup.get('AS_WR_STREETNUM');
    const isPayeeStreetNumberControl = numberControl === this.formCheckDetailedGroup.get('AS_PAYEE_STREETNUM');

    // Keep payee street number optional while "same address" is active.
    if (isPayeeStreetNumberControl && this.isSameAddressChecked) {
      numberControl.clearValidators();
      numberControl.updateValueAndValidity({ emitEvent: false });
      return;
    }

    // Respect explicit PO Box checkbox mode for work address street number.
    // In this mode, validators must remain cleared while user types PO Box number in street name.
    if (isWorkStreetNumberControl && this.isPoBox) {
      numberControl.clearValidators();
      numberControl.updateValueAndValidity({ emitEvent: false });
      return;
    }

    const containsPoBox = val && this.containsPoBox(val);

    if (containsPoBox) {
      // Removes required validator if street name contains PO Box
      numberControl.setValidators([]);
    } else {
      // Adds required validator if street name does not contain PO Box
      numberControl.setValidators([
        Validators.pattern(/^[1-9]\d*[A-Za-z]?$/),
        Validators.required
      ]);
    }

    numberControl.updateValueAndValidity({ emitEvent: false });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.container.id == 'Available Contractors') {
      this.contractorStatus = true;
      this.contractorPayload = [
        {
          "email": event.item.data,
          "role": "CONT"

        }
      ]
      this.workActions();
    } else {
      this.contractorStatus = false;
      this.contractorPayload = [
        {
          "email": event.item.data,
          "role": "CONT"

        }
      ]
      this.workActions();
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  workActions() {
    this.selectedOrg = this.formDetailedGroup.value['AS_ORG_CD']
    this.organizationMaintainenceService.saveContractor(this.contractorStatus, this.selectedOrg, this.contractorPayload).subscribe(res => {
      ////console.log('save cont', res);
      if (!res.Action) {
        this.contractorStatus = false;
        this.contractorPayload = [];
        this.snackBar.open('Success', 'Ok', {
          duration: 2000,
          verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
          horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
          panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
        })
      } else {
        Swal.fire({
          text: res.Message,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    })
  }

  ngAfterViewInit(): void {
    this.dataSourceOrganization.sort = this.sort;
  }
  
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      'description': [null],
      'orgCode': [null],
      'telephone': [null],
      'city': [null],
      'externalkey': [null],
    });

    this.formDetailedGroup = this.formBuilder.group({
      'AS_ORG_DESC': ['', Validators.required],
      'AL_ORG_ACTIVE': [true],
      'AS_ORG_CD': ['', [Validators.maxLength(10), Validators.required]],
      'AS_WR_EXTERNAL_KEY': [''],
      'AS_WR_STREETNUM': ['', [Validators.pattern(/^[1-9]\d*[A-Za-z]?$/), Validators.required]],
      'AS_WR_STREETNAME': ['', Validators.required],
      'AS_WR_CITY': ['', Validators.required],
      'AS_WR_STATE': ['', [Validators.minLength(2), Validators.maxLength(2), Validators.required]],
      'AS_WR_ZIP': ['', [Validators.minLength(5), Validators.maxLength(10), Validators.pattern(/^-?(0|[0-9]\d*)?$/), Validators.required]],
      'AS_WR_PHONE': ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.required]],
      'WR_EMAIL': ['', [Validators.pattern(this.emailregex), Validators.required]],
      'CLASSIFICATION_CD': ['',Validators.required],
      'TYPE_CD': [''],
      'LICENSE': [''],
      'LICENSEEXP': ['',Validators.required],
      'LICENSENAME': [''],
      'NOTES': [''],
      'AS_WR_FIELD_REP': [''],
      'AS_WR_W9': [''],
      'AS_WR_SAFETY': [''],
      'AS_WR_STATE_PARTICIPATION': ['', [Validators.minLength(2), Validators.maxLength(2)]]
    });

    this.formCheckDetailedGroup = this.formBuilder.group({
      'AS_PAYEE_FULLNAME': ['', Validators.required],
      'AS_PAYEE_STREETNUM': ['', Validators.required],
      'AS_PAYEE_STREETNAME': ['', Validators.required],
      'AS_PAYEE_CITY': ['', Validators.required],
      'AS_PAYEE_STATE': ['', [Validators.minLength(2), Validators.maxLength(2), Validators.required]],
      'AS_PAYEE_ZIP': ['', [Validators.minLength(5), Validators.maxLength(10), Validators.pattern(/^-?(0|[0-9]\d*)?$/), Validators.required]],
      'AS_PAYEE_ADDRESS1': [''],
      'AS_PAYEE_ADDRESS2': [''],
    });

    this.formDocGroup = this.formBuilder.group({
      "DESCRIPTION": ['', Validators.required],
      "ACTIVE": [true],
      "TITLE": ['', Validators.required],
      "SYSTEMIMAGES_ID": [''],
      "IMAGEFILENAME": [{ value: '', disabled: true }],
      "DOCTYPE_CD": ['', Validators.required]
    });

    this.formAccredGroup = this.formBuilder.group({
      "CLASSIFICATION": ['',Validators.required],
      "LICENCENUMBER":['',Validators.required],
      "ISSUED":['',Validators.required],
      "EXPIRES":['',Validators.required],
      "STATE":[''],
      "SPECIALTY":['']
    }, { validator: this.dateLessThanValidator('ISSUED', 'EXPIRES') });

    this.formQAGroup = this.formBuilder.group({
      "QAPERCENTAGE": ['', [Validators.required, this.percentageValidator()]],
      "PROGRAMDETAILID":['',Validators.required]
    });

  }

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    console.log('tabChangeEvent.index-----', tabChangeEvent)
    this.selectedIndex = tabChangeEvent.index;
    if (this.selectedIndex == 0 || this.selectedIndex == 2 || this.selectedIndex == 7 || this.selectedIndex == 6) {
      this.hideSave = false;
    } else {
      this.hideSave = true;
    }
    // if (this.formStatus) {
    //   console.log('test')
    //   // Swal.fire({
    //   //   title: 'Are you sure?',
    //   //   text: "There are some unsaved changes ",
    //   //   icon: 'warning',
    //   //   confirmButtonText: 'Yes, discard it!',
    //   //   showCancelButton: true,
    //   // }).then((result) => {
    //   //   if (result.value) {
    //   //     Swal.fire(
    //   //       'Discarded!',
    //   //       'Your changes are discarded.',
    //   //       'success'
    //   //     )
    //   //   }
    //   // })
    // } else {

    // }

  }
  // QA Tab
  addQaDetails() {
    this.addOrEditText = 'Add New';
    this.editQa = true;
    this.addQa = true;
  }
  
  onPoBoxToggle(checked: boolean): void {
    this.isPoBox = checked;
    const streetNumCtrl = this.formDetailedGroup.get('AS_WR_STREETNUM')!;
    const streetNameCtrl = this.formDetailedGroup.get('AS_WR_STREETNAME')!;
    if (checked) {
      streetNumCtrl.setValue('', { emitEvent: false });
      streetNameCtrl.setValue('PO BOX', { emitEvent: false });
    } else {
      if (this.isPoBoxString(streetNumCtrl.value)) {
        streetNumCtrl.setValue('', { emitEvent: false });
      }

      if (this.isPoBoxString(streetNameCtrl.value)) {
        streetNameCtrl.setValue('', { emitEvent: false });
      }

    }
    this.applyPoBoxState(checked);
    this.cdr.markForCheck();
  }

  // Enable or disable validators for the street number field based on whether it's a PO Box or not
  private applyPoBoxState(checked: boolean): void {
    const streetNumCtrl = this.formDetailedGroup.get('AS_WR_STREETNUM');

    if (!streetNumCtrl) {
      return;
    }

    if (checked) {
      // PO Box mode: clear all validators
      streetNumCtrl.clearValidators();
    } else {
      // Regular street number mode: set required and pattern validators,
      // unless the street name itself contains a PO Box value
      const streetNameVal = this.formDetailedGroup.get('AS_WR_STREETNAME')?.value;
      const streetNumVal = streetNumCtrl.value;
      const poBoxInName = this.containsPoBox(streetNameVal) || this.isPoBoxString(streetNameVal);
      const poBoxInNum = this.isPoBoxString(streetNumVal);
      if (!poBoxInName && !poBoxInNum) {
        streetNumCtrl.setValidators([
          Validators.pattern(/^[1-9]\d*[A-Za-z]?$/),
          Validators.required
        ]);
      } else {
        streetNumCtrl.clearValidators();
      }
    }

    if (checked && this.isSameAddressChecked) {
      streetNumCtrl.setValue('', { emitEvent: false });
    }

    streetNumCtrl.updateValueAndValidity({ emitEvent: false });
  }

  private isPoBoxString(val: any): boolean {
    if (val == null) return false;
    const s = String(val).trim().toLowerCase();
    return s === 'po box'|| s === 'p.o. box' || s === 'po-box' || s === 'p.o.-box' || s === 'pobox' || s === 'po';
  }

  containsPoBox(str: string): boolean {
    if (!str) return false;
    const upperStr = str.toUpperCase().trim();
    const poBoxRegex = /\b(P[.\s]*O[.\s]*BOX|POST[.\s]*OFFICE[.\s]*BOX)\b/i;
    return poBoxRegex.test(upperStr);
  }

  clearQaDetails() {          
    if (this.formQAGroup.dirty) {
      Swal.fire({
        title: 'Are you sure?',
        text: "There are some unsaved changes ",
        icon: 'warning',
        confirmButtonText: 'Yes, discard it!',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Discarded!',
            'Your changes are discarded.',
            'success'
          )
          this.formQAGroup.reset();
          this.editQa = false;
        } 
      });
    }
    else{
        this.editQa = false;
        this.formQAGroup.reset();
     }
  }
  
  editQaPercentage(data: Qadetail){
    this.formQAGroup.controls['PROGRAMDETAILID'].setValue(data.ProgramDetailId);
    this.formQAGroup.controls['QAPERCENTAGE'].setValue(data.QAPercentage);    

    this.addOrEditText = 'Edit ';
    this.addQa=false;
    this.editQa = true;
  }

  onQaPercentageSubmit() {    
    if(this.formQAGroup.valid){      
      const isProgramDetailIdPresent = this.dataSourceQaDetails.data.some(data => data.ProgramDetailId === this.formQAGroup.value.PROGRAMDETAILID);
      if (isProgramDetailIdPresent && this.addQa) {
        Swal.fire(
          'Error!',
          'An entry with this Program already exists. Please update the existing entry or remove it before adding a new one',
          'warning'
        );
      }
      else {
        const qaPercentage = this.formQAGroup.value;
        this.organizationMaintainenceService.updateQaDetails(this.selectedOrg,qaPercentage).subscribe ( res => {
          if(!res.Action){     
            const isQapercentagePresent = this.dataSourceQaDetails.data.some(data => data.ProgramDetailId === qaPercentage.PROGRAMDETAILID);
            if (!isQapercentagePresent) {
              const newQaPercentage = {
                ProgramDetailId: qaPercentage.PROGRAMDETAILID,
                QAPercentage: Number(qaPercentage.QAPERCENTAGE)
              } as Qadetail;
              this.dataSourceQaDetails.data.push(newQaPercentage);
            } else {
              const updatedData = this.dataSourceQaDetails.data.find(data => data.ProgramDetailId === qaPercentage.PROGRAMDETAILID);
              updatedData.ProgramDetailId = qaPercentage.PROGRAMDETAILID;
              updatedData.QAPercentage = Number(qaPercentage.QAPERCENTAGE);
            }
            this.editQa = false;
            this.formQAGroup.reset();

            this.refreshOrg(this.selectedOrg);
            Swal.fire(
              'Saved!',
               res.Message,
              'success'
            );
          } else{
            Swal.fire(
              'Error!',
               res.Message,
              'warning'
            );
          }
        }, err => {
          
        });
      }        
  }
}

deleteQaPercentage(data,i){
  Swal.fire({
    title: 'Are you sure?',
    text: "Delete this QA Percentage",
    icon: 'warning',
    confirmButtonText: 'Yes, delete it!',
    showCancelButton: true,
  }).then((result) => {
    if (result.value) {
      this.organizationMaintainenceService.deleteQaPercentage(this.selectedOrg, data).subscribe ( res=> {
        if(!res.Action){     
          this.dataSourceQaDetails.data = this.dataSourceQaDetails.data.filter(dataSource => dataSource.ProgramDetailId !== data.ProgramDetailId);              
          this.refreshOrg(this.selectedOrg);
      Swal.fire(
        'Deleted!',
        'QA Percentage has been deleted.',
        'success'
      )
        } else {
          Swal.fire(
            'Error!',
              res.Message,
            'warning'
          );
        }
      }, err =>{

      });      
    }
});
}


    // Accreditations Tab ////////////////////////////////////////////////////////////////////////////////////////

    addAccreditations(){
      this.addOrEditText = 'Add New';
      this.editAccred = true; 
      this.addAccred = true; 
    }    
  
    clearAccred(){
      
      
      if(this.formAccredGroup.dirty){
  
        Swal.fire({
          title: 'Are you sure?',
          text: "There are some unsaved changes ",
          icon: 'warning',
          confirmButtonText: 'Yes, discard it!',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            Swal.fire(
              'Discarded!',
              'Your changes are discarded.',
              'success'
            )
            this.formAccredGroup.reset();
            this.editAccred = false;
            this.oldAccreditation = null;
          } else {
    
          }
        })
      }
      else{
          this.editAccred = false;
          this.formAccredGroup.reset();
       }
    }
  
    editaccreditations(data){
      this.oldAccreditation = data
      this.formAccredGroup.controls['CLASSIFICATION'].setValue(data['CLASSIFICATION']);
      this.formAccredGroup.controls['LICENCENUMBER'].setValue(data['LICENCENUMBER']);
      if(data['ISSUED'] != null){
        this.formAccredGroup.controls['ISSUED'].setValue(new Date(data['ISSUED'])); 
      }
      this.formAccredGroup.controls['EXPIRES'].setValue(new Date(data['EXPIRES']));
      this.formAccredGroup.controls['STATE'].setValue(data['STATE']);
      this.formAccredGroup.controls['SPECIALTY'].setValue(data['SPECIALTY']);
      
    
      this.addOrEditText = 'Edit ';
      this.addAccred=false;
      this.editAccred = true;
    }

    deleteaccreditations(data,i){

        Swal.fire({
          title: 'Are you sure?',
          text: "Delete this accreditation",
          icon: 'warning',
          confirmButtonText: 'Yes, delete it!',
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.organizationMaintainenceService.deleteAccreditation(this.selectedOrg, data).subscribe ( res=> {
            console.log(res);
              if(!res.Action){     
                this.organizationDetails.AccreditationsTab.splice(i,1);
                this.dataSourceAccreditations.data = this.organizationDetails.AccreditationsTab;              
            Swal.fire(
              'Deleted!',
              'Accreditation has been deleted.',
              'success'
            )
              } else {
                Swal.fire(
                  'Error!',
                    res.Message,
                  'warning'
                );
              }
            }, err =>{

            });
            
          }


      });
    }
  
    onAccreditationSubmit(){
     
      if(this.formAccredGroup.valid){
        this.newAccreditation = this.formAccredGroup.value;     
        this.newAccreditation.EXPIRES = format(new Date(this.formAccredGroup.value.EXPIRES), 'yyyy-MM-dd\'T\'00:00:00');        
        this.newAccreditation.ISSUED = format(new Date(this.formAccredGroup.value.ISSUED), 'yyyy-MM-dd\'T\'00:00:00');      
        if (this.addAccred){
          this.organizationMaintainenceService.addAccreditation(this.selectedOrg,this.newAccreditation).subscribe ( res => {
            if(!res.Action){     
              this.organizationDetails.AccreditationsTab.push(this.newAccreditation);
              this.editAccred = false;
              this.formAccredGroup.reset();
              Swal.fire(
                'Saved!',
                'Your Accreditation has been added.',
                'success'
              );
            } else{
              Swal.fire(
                'Error!',
                  res.Message,
                'warning'
              );
            }
          }, err => {
            
          });

        }
        else{
          if(this.organizationDetails.OrganizationTab.CLASSIFICATION_CD == this.formAccredGroup.value.CLASSIFICATION  && this.organizationDetails.OrganizationTab.LICENSEEXP == this.formAccredGroup.value.EXPIRES ){           
            this.formDetailedGroup.controls['LICENSE'].patchValue(this.formAccredGroup.value.LICENCENUMBER);            
          }     
          this.organizationMaintainenceService.editAccreditation(this.selectedOrg,this.newAccreditation).subscribe ( res => {
            if(!res.Action){  
                 
              for(let i = 0; i < this.organizationDetails.AccreditationsTab.length; i++){
                const obj = this.organizationDetails.AccreditationsTab[i];
                if(obj == this.oldAccreditation ){
                  this.organizationDetails.AccreditationsTab.splice(i,1);
                  this.organizationDetails.AccreditationsTab.push(this.newAccreditation);
                }
              }
              this.editAccred = false;
              this.formAccredGroup.reset();
              Swal.fire(
                'Saved!',
                'Your Accreditation has been edited.',
                'success'
              );
            } else{
              Swal.fire(
                'Error!',
                  res.Message,
                'warning'
              );
            }
          }, err => {
            
          });
        }

      }
      

      
  
    }

  sameAddress(checked: boolean): void {
    this.isSameAddressChecked = checked;
    const payeeStreetNumCtrl = this.formCheckDetailedGroup.get('AS_PAYEE_STREETNUM')!;
    const payeeStreetNameCtrl = this.formCheckDetailedGroup.get('AS_PAYEE_STREETNAME')!;

    if (!checked) {
      this.determinePoBoxValidations(payeeStreetNameCtrl.value, payeeStreetNumCtrl);
      return;
    }

    payeeStreetNumCtrl.clearValidators();
    payeeStreetNumCtrl.markAsUntouched();
    payeeStreetNumCtrl.updateValueAndValidity({ emitEvent: false });

    this.formCheckDetailedGroup.controls['AS_PAYEE_STREETNUM'].setValue(this.isPoBox ? '' : this.formDetailedGroup.controls['AS_WR_STREETNUM'].value);
    this.formCheckDetailedGroup.controls['AS_PAYEE_STREETNAME'].setValue(this.formDetailedGroup.controls['AS_WR_STREETNAME'].value);
    this.formCheckDetailedGroup.controls['AS_PAYEE_CITY'].setValue(this.formDetailedGroup.controls['AS_WR_CITY'].value);
    this.formCheckDetailedGroup.controls['AS_PAYEE_STATE'].setValue(this.formDetailedGroup.controls['AS_WR_STATE'].value);
    this.formCheckDetailedGroup.controls['AS_PAYEE_ZIP'].setValue(this.formDetailedGroup.controls['AS_WR_ZIP'].value);
  }

  doSearch() {
    this.isOrgSelected = true;
    this.selectedIndex = 0;
    this.organizationDetails = {};
    this.programStatusTab = {} as ProgramStatusTab;
    this.qaDetailsTab = {} as QaDetailsTab;

    this.editQa = false;
    this.addQa = false;
    this.editAccred = false;
    this.addAccred = false;
  }

  doClear() {
    if (this.formDetailedStatus || this.formDetailedStatus) {
      // console.log('test')
      Swal.fire({
        title: 'Are you sure?',
        text: "There are some unsaved changes ",
        icon: 'warning',
        confirmButtonText: 'Yes, discard it!',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          if (!this.orgType) {
            this.formDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)
            this.formCheckDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)

            const classificationControl = this.formDetailedGroup.get('CLASSIFICATION_CD');
            if (!classificationControl?.value) {
             classificationControl.patchValue(this.classificationOpt[0].CLASSIFICATION_CD);
            }
          } else {
          this.formDetailedGroup.reset();
          this.formCheckDetailedGroup.reset();
          }
          Swal.fire(
            'Discarded!',
            'Your changes are discarded.',
            'success'
          )
        } else {

        }
      })
    }

    if (this.formDocStatus) {
      // console.log('test')
      Swal.fire({
        title: 'Are you sure?',
        text: "There are some unsaved changes ",
        icon: 'warning',
        confirmButtonText: 'Yes, discard it!',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.docSavetype) {
            this.formDocGroup.reset();
          }else {
            this.formDocGroup.patchValue(this.sysImageId);
          }
          Swal.fire(
            'Discarded!',
            'Your changes are discarded.',
            'success'
          )
        } else {

        }
      })
    }
  }

  doOrgClear() {
    this.formGroup.reset();
    this.dataSourceOrganization.data = [];
  }

  entered(event: CdkDragEnter<string[]>) {
    ////console.log('Entered', event.item);
  }

  exited(event: CdkDragExit<string[]>) {
    ////console.log('Exited', event.item);
  }

  doSave() {
    // console.log("licenseexp val = " + this.formDetailedGroup.controls['LICENSEEXP'].value);
    let mandat;
    this.formDetailedGroup.value['AL_ORG_ACTIVE'] = this.formDetailedGroup.value['AL_ORG_ACTIVE'] ? 1 : 0;
    if (!this.orgType) {
      this.selectedOrg = this.formDetailedGroup.value['AS_ORG_CD']
      mandat = this.organizationDetails.OrganizationTab
    } else {
      mandat = this.addOrgDetails
      // this.selectedOrg = 'NEW'
      this.selectedOrg = this.formDetailedGroup.value['AS_ORG_CD']
    }
    if (this.selectedIndex === 0) {
      if(this.formDetailedGroup.value['LICENSEEXP'] == null){
        this.formDetailedGroup.value['LICENSEEXP'] = new Date();
      }
      const formdta = {
        "OrganizationTab": { ...mandat, ...this.formDetailedGroup.value, ...this.formCheckDetailedGroup.value }
      }
      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass: this.className});
      this.organizationMaintainenceService.saveOrganization(this.orgType, this.selectedOrg, formdta).subscribe(res => {
        ////console.log('save org', res);
        dialogRef.close();
        if (!res.Action) {
          Swal.fire({
            text: 'Changes saved',
            icon: 'success',
            confirmButtonText: 'OK',
            });
          this.addAccred = false;
          // this.snackBar.open('Success', 'Ok', {
          //   duration: 2000,
          //   verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
          //   horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
          //   panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          // })
          // if(this.newOrgSel){
          //   this.newOrganization = {
          //     ORGANIZATION_CD: formdta.OrganizationTab.AS_ORG_CD,
          //     ORGANIZATION_DESC: formdta.OrganizationTab.AS_ORG_DESC,
          //     EXTERNALKEY: formdta.OrganizationTab.AS_WR_EXTERNAL_KEY,
          //     CITY: formdta.OrganizationTab.AS_WR_CITY,
          //     PHONE_NUMBER: formdta.OrganizationTab.AS_WR_PHONE,
  
          //   };
          //   this.handleClick(this.newOrganization);
          //   }         
          this.isOrgSelected = false;
          this.newOrgSel = false;
          this.isLegacy = false;
          if(this.formDetailedGroup.controls.LICENSE.dirty){
            if(!this.organizationDetails.isNullOrUndefined()){
              for(let i of this.organizationDetails?.AccreditationsTab){          
                if((i.EXPIRES == this.organizationDetails?.OrganizationTab?.LICENSEEXP) && (i.CLASSIFICATION == this.organizationDetails?.OrganizationTab?.CLASSIFICATION_CD)){
                  i['LICENCENUMBER'] = this.formDetailedGroup.controls.LICENSE.value;             
                  this.dataSourceAccreditations.data = this.organizationDetails.AccreditationsTab; 
                }                     
              }
            }
          }
          
          this.selectedOrg = this.formDetailedGroup.controls['AS_ORG_CD'].value;     
          this.refreshOrg(this.selectedOrg);
          if(this.orgType){
            this.orgType = false;
          }

        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      })

    } else if (this.selectedIndex === 1) {

      // this.organizationMaintainenceService.saveContractor(this.contractorStatus, this.selectedOrg, this.contractorPayload).subscribe(res => {
      //   ////console.log('save cont', res);
      //   if (!res.Action) {
      //     this.contractorStatus = false;
      //     this.contractorPayload = [];
      //     this.snackBar.open('Success', 'Ok', {
      //       duration: 2000,
      //       verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
      //       horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
      //       panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
      //     })
      //   } else {
      //     Swal.fire({
      //       text: res.Message,
      //       icon: 'error',
      //       confirmButtonText: 'OK',
      //     })
      //   }
      // })
      // this.contractors = Contractors;
      // this.organizationContractors = OrganizationContractors;

    } else if (this.selectedIndex === 2) {
      const result = this.organizationDetails.WorkorderTypesTab || [];
      const workOrd = result.map((val, index) => {
        val.SELECTED = val.SELECTED ? 1.0 : 0.0;
        return val;
      })
      const formdta = {
        "WorkorderTypesTab": workOrd
      }
      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass:this.className});
      this.organizationMaintainenceService.saveOrganization(this.orgType, this.selectedOrg, formdta).subscribe(res => {
        ////console.log('save typoes', res);
        dialogRef.close();
        if (!res.Action) {
          this.snackBar.open('Success', 'Ok', {
            duration: 2000,
            verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
            horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
            panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          })
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      })
    } else if (this.selectedIndex === 3) {

    } else if (this.selectedIndex === 4) {

    } else if (this.selectedIndex === 6) {
      const result = this.organizationDetails.ServiceTypesTab || [];
      const workOrd = result.map((val, index) => {
        val.SELECTED = val.SELECTED ? 1.0 : 0.0;
        return val;
      });
      const formdta = {
        "ServiceTypesTab": workOrd
      }
      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass:this.className});
      this.organizationMaintainenceService.saveOrganization(this.orgType, this.selectedOrg, formdta).subscribe(res => {
        dialogRef.close();
        if (!res.Action) {
          this.snackBar.open('Success', 'Ok', {
            duration: 2000,
            verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
            horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
            panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          })
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      });
    } else if (this.selectedIndex === 7) {
      // Date Format Conversion
      this.programStatusTab?.ProgramStatus.forEach(p => {
        p.OrientationDate = p.OrientationDate ? format(new Date(p.OrientationDate), 'yyyy-MM-dd\'T\'00:00:00') : null;
      });
      const formdta = {
        "ProgramStatusTab": this.programStatusTab?.ProgramStatus
      }

      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass:this.className,disableClose: true});
      this.organizationMaintainenceService.saveOrganization(this.orgType, this.selectedOrg, formdta).subscribe(res => {
        dialogRef.close();
        if (!res.Action) {
          this.snackBar.open('Success', 'Ok', {
            duration: 2000,
            verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
            horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
            panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          })
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      })
    }
  }

  refreshOrg(oegCd: string){
    // Get updated org informantion
    this.organizationMaintainenceService.getSelectedOrganizationDetails(this.selectedOrg).subscribe(res => {
      console.log('details---', res)
      this.isOrgSelected = false;
      this.organizationDetails = res
      const { UsersTab: { OrganizationContractors = [], Contractors = [] } } = this.organizationDetails || {};
      const { CLASSIFICATIONS = [], TYPES = [], CLASSIFICATION_CD = '', TYPE_CD = '' } = this.organizationDetails.OrganizationTab || {}
      this.typeOpt = TYPES;
      this.classificationOpt = CLASSIFICATIONS;      
      this.dataSourceAccreditations.data = this.organizationDetails.AccreditationsTab;      
      this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
      this.documentTypeOpt = this.organizationDetails.DocumentsTab.DOC_TYPES;
      this.formDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)
      this.formCheckDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)
      this.contractors = Contractors;
      this.organizationContractors = OrganizationContractors;

      this.programStatusTab = res.ProgramStatusTab;      
      this.programStatusTab?.ProgramStatus.forEach(p => {
        p.SelectedStatusCd = p.SelectedStatusCd ? p.SelectedStatusCd : this.programStatusTab?.Values[0]?.Id;
        p.OrientationDate = p.OrientationDate ? format(new Date(p.OrientationDate), 'yyyy-MM-dd\'T\'00:00:00') : null;
      });

      this.qaDetailsTab = res?.QaDetailsTab;
      this.dataSourceQaDetails.data = res?.QaDetailsTab?.QADetails;
      this.dataSourceQaStats.data = res?.QaDetailsTab?.QAStats;

      this.addAccred= false;     
      this.readonlyOrgCD = true;
      this.formDetailedGroup.setValue({
        'CLASSIFICATION_CD': CLASSIFICATION_CD,
        'TYPE_CD': TYPE_CD
      });}, err => {
        this.isOrgSelected = true;
        Swal.fire({
          text: err,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      });
  }

  sortCustData(sort: Sort) {
    const data = this.organization;
    if (!sort.active || sort.direction === '') {
      this.organization = [];
      this.dataSourceOrganization.data = data;
      return;
    }

    this.dataSourceOrganization.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'ORGANIZATION_DESC': return this.compare(a.ORGANIZATION_DESC, b.ORGANIZATION_DESC, isAsc);
        case 'ORGANIZATION_CD': return this.compare(a.ORGANIZATION_CD, b.ORGANIZATION_CD, isAsc);
        case 'CITY': return this.compare(a.CITY, b.CITY, isAsc);
        case 'PHONE_NUMBER': return this.compare(a.PHONE_NUMBER, b.PHONE_NUMBER, isAsc);
        case 'EXTERNALKEY': return this.compare(a.EXTERNALKEY, b.EXTERNALKEY, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onOrganisationSubmit(data) {
    this.organizationSearching = true;
    let params = '';
    for (let [key, value] of Object.entries(data)) {
      if (value) params += `&${key}=${value}`;
      else params += `&${key}`
    }
    // this.organizationForm = data; .replace(/&\s*$/, "")
    this.organizationMaintainenceService.getOrganizationSearch(params).subscribe(res => {
      //console.log('ser org', res)
      this.organizationSearching = false;
      this.organization = res
      this.dataSourceOrganization.data = this.organization;
    }, err => {
      this.organizationSearching = false;
      //console.log('add org err', err)
      if (err == 'Incorrect response!') {
        Swal.fire({
          text: 'No Records Found',
          icon: 'error',
          confirmButtonText: 'OK',
        })
      } else {
        Swal.fire({
          text: err,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    });
  }

  singleClick(row) {
    this.isOrgSelected = true;
    this.orgSelection.isSelected(row)
  }

  addOrganisation() {
    this.orgType = true;
    this.isOrgSelected = false;
    this.addAccred = true;
    this.readonlyOrgCD = false;
    this.organizationMaintainenceService.addNewOrganization().subscribe(res => {
      this.organizationDetails = {};
      this.dataSourceAccreditations.data = this.organizationDetails?.AccreditationsTab;
      this.dataSourceQaDetails.data = this.organizationDetails?.QADetails;
      this.dataSourceQaStats.data = this.organizationDetails?.QAStats;
      res['AL_ORG_ACTIVE'] = 1;
      this.newOrgSel = true;
      this.addOrgDetails = res;
      this.addNewOrg = res;
      const { CLASSIFICATIONS = [], TYPES = [], CLASSIFICATION_CD = '', TYPE_CD = '' } = res || {}
      this.typeOpt = TYPES;
      this.classificationOpt = CLASSIFICATIONS;
      this.formDetailedGroup.patchValue(res)
      this.formCheckDetailedGroup.patchValue(res)
    })
  }

  onDocumentsChange(event) {
    // ////console.log('onDocumentsChange event.checked ', event.checked);
    if (event.checked) {
      const activeDocs = this.organizationDetails.DocumentsTab.ORG_DOCS.filter(function (doc) {
        return doc.ACTIVE == 1;
      });
      this.dataSourceDocuments.data = activeDocs;
    } else {
      this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
    }
  }

  addDocument() {
    this.formDocGroup.reset()
    this.docType = true;
    this.docSavetype = true;    
    this.isDocActiveDisabled = true;
    this.docActionName = 'Upload New Document';
    this.formDocGroup.patchValue({
      'DOCTYPE_CD': this.documentTypeOpt[0].TYPE_CD,
      'ACTIVE': [true]
    });
  }

  deleteZip(zip, i) {

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want delete it?",
      icon: 'warning',
      confirmButtonText: 'Yes, delete it!',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        // ////console.log('deleteZip', zip);
        const item = zip;
        this.organizationMaintainenceService.deleteZip(this.selectedOrg, zip).subscribe(res => {
          ////console.log('deletezip', res);
          if (!res.Action) {
            this.organizationDetails.ZipCodesTab.splice(i, 1);
            this.snackBar.open('Success', 'Ok', {
              duration: 2000,
              verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
              horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
              panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
            });
          } else {
            Swal.fire({
              text: res.Message,
              icon: 'error',
              confirmButtonText: 'OK',
            })
          }
        })
      }
    })
  }

  checkFileExt(ext) {
    let extension;
    switch (ext) {//check image's extension
      case "data:image/jpeg;base64":
        extension = "jpeg";
        break;
      case "data:image/png;base64":
        extension = "png";
        break;
      case "data:application/vnd.ms-excel;base64":
        extension = "csv";
        break;
      case "data:text/csv;base64":
        extension = "csv"
        break;
      case "data:application/pdf;base64":
        extension = "pdf";
        break;  
      default://should write cases for more images types
        extension = "jpg";
        break;
    }
    return extension;
  }

  addZipItem() {
    ////console.log('zip item', this.addZip);
    const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass:this.className});
    this.organizationMaintainenceService.saveZip(this.selectedOrg, [this.addZip]).subscribe(res => {
      ////console.log('addzip', res);
      dialogRef.close();
      if (!res.Action) {
        this.organizationDetails.ZipCodesTab.push(this.addZip)
        this.addZip = '';
        this.snackBar.open('Success', 'Ok', {
          duration: 2000,
          verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
          horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
          panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
        });
      } else {
        Swal.fire({
          text: res.Message,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }

    })
  }

  exportZips() {
    this.exportUtilService.downloadFile(this.organizationDetails.ZipCodesTab, 'jsontocsv', this.selectedOrg)
  }

  importZips() {

  }

  downloadFile(data, mimeType, doc) {
    var binaryString = window.atob(data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    var blob = new Blob([bytes]);
    const downloadURL = URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = downloadURL;
    a.download = doc.IMAGEFILENAME;
    a.click();
  }

  getMimeType(ext) {
    let extension;
    switch (ext) {//check image's extension
      case ".jpeg":
        extension = "image/jpeg";
        break;
      case ".jpg":
        extension = "image/jpg";
        break;  
      case ".png":
        extension = "image/png";
        break;
      case ".csv":
        extension = "application/vnd.ms-excel";
        break;
      case ".pdf":
        extension = "application/pdf";
        break;  
      case ".doc":
        extension = "application/doc";
        break; 
      case ".docx":
        extension = "application/docx";
        break; 
      default://should write cases for more images types
        extension = "image/jpeg";
        break;
    }
    return extension;
  }

  viewDoc(doc) {
    if (doc && doc.IMAGE_ID) {
      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Loading...'},panelClass:this.className, disableClose: true});
      this.organizationMaintainenceService.viewAttachDoc(this.selectedOrg, doc.IMAGE_ID).subscribe(res => {
        dialogRef.close();
        if (!res.Action) {
          this.downloadFile(res.Content, this.getMimeType(doc.IMAGEFILENAME.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)), doc);
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }

      })
    } else {
      Swal.fire({
        text: 'Attachment is not available',
        icon: 'warning',
        confirmButtonText: 'OK',
      })
    }
  }

  deleteDoc(doc) {

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to delete it? ",
      icon: 'warning',
      confirmButtonText: 'Yes, delete it!',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        // Swal.fire(
        //   'Discarded!',
        //   'Your changes are discarded.',
        //   'success'
        // )
        ////console.log('deleteDoc', doc);
        this.organizationMaintainenceService.deleteDoc(this.selectedOrg, doc.SYSTEMIMAGES_ID).subscribe(res => {
          //console.log('deletedoc', res);
          if (res === null) {
            this.organizationDetails.DocumentsTab.ORG_DOCS.forEach((obj) => {
              if (obj.SYSTEMIMAGES_ID === doc.SYSTEMIMAGES_ID) obj.ACTIVE = 0;
            });
            this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
            this.snackBar.open('Success', 'Ok', {
              duration: 2000,
              verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
              horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
              panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
            });
          } else {
            Swal.fire({
              text: res.Message,
              icon: 'error',
              confirmButtonText: 'OK',
            })
          }
        })
      }
    })
  }

  editDoc(doc) {
    this.docActionName = 'Update Document'
    this.sysImageId = doc;
    this.docType = true;
    this.isDocActiveDisabled = false;
    this.docSavetype = false;
    this.formDocGroup.patchValue({
      "DESCRIPTION": doc.DESCRIPTION,
      "ACTIVE": doc.ACTIVE === 1,
      "TITLE": doc.TITLE,
      "SYSTEMIMAGES_ID": doc.SYSTEMIMAGES_ID,
      "IMAGEFILENAME": doc.IMAGEFILENAME,
      "DOCTYPE_CD": doc.TYPE_CD
    });
  }

  updateDoc() {
    let doc = this.formDocGroup.value;
    const CONTENT = this.extractedFileData ? this.extractedFileData[1] : this.extractedFileData;
    doc['ACTIVE'] = doc.ACTIVE ? 1 : 0;
    if (this.docSavetype) {

      let result
      if (this.orgType && this.docSavetype) {
        result = [{
          "OFFICE_ID": this.addOrgDetails["AS_OFFICE_ID"],
          "TYPE_CD": this.formDocGroup.value['DOCTYPE_CD'],
          "IMAGE_ID": "",
          "IMAGEFILENAME": this.fileName,
          "EXTERNALKEY": this.formDetailedGroup.value['AS_ORG_CD'],
          "LASTUPDATED": new Date().toISOString(),
          "DESCRIPTION": "",
          "USER_ID": this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId,
          "SYSTEMIMAGES_ID": "",
          "ACTIVE": 0,
          "TITLE": "",
        }]
      } else if (!this.orgType && this.docSavetype) {
        result = [{
          "OFFICE_ID": this.formDetailedGroup.value["AS_OFFICE_ID"],
          "TYPE_CD": this.formDocGroup.value['DOCTYPE_CD'],
          "IMAGE_ID": "",
          "IMAGEFILENAME": this.fileName,
          "EXTERNALKEY": this.formDetailedGroup.value['AS_ORG_CD'],
          "LASTUPDATED": new Date().toISOString(),
          "DESCRIPTION": "",
          "USER_ID": this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId,
          "SYSTEMIMAGES_ID": "",
          "ACTIVE": 0,
          "TITLE": "",
        }]
      } else {
        result = this.organizationDetails.DocumentsTab.ORG_DOCS.filter(item => {
          return item.SYSTEMIMAGES_ID == doc.SYSTEMIMAGES_ID;
        })
      }

      let final = { ...result[0], ...doc }
      if (CONTENT) final = { ...final, CONTENT }
      const payload = {
        "DocumentsTab": [final]
      }
      //console.log(' this.formDocGroup update', payload)
      const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Saving...'},panelClass:this.className, disableClose: true});
      this.organizationMaintainenceService.updateDoc(this.selectedOrg, payload).subscribe(res => {
        ////console.log('addzip', res);
        dialogRef.close();
        this.isDocUploaded = true;
        if (!res.Action) {
          // this.organizationDetails.DocumentsTab.ORG_DOCS.push(final)
          this.snackBar.open('Success', 'Ok', {
            duration: 2000,
            verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
            horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
            panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          });
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        this.closeDocUpdate();
      });

    } else {
      //existing doc update
      const result = this.organizationDetails.DocumentsTab.ORG_DOCS.filter(item => {
        return item.SYSTEMIMAGES_ID == doc.SYSTEMIMAGES_ID;
      })
      if (this.fileName) result[0].IMAGEFILENAME = this.fileName;
      let final = { ...result[0], ...doc }
      if (CONTENT) final = { ...final, CONTENT }
      const payload = {
        "DocumentsTab": [final]
      }
      //console.log(' this.formDocGroup update', payload)
      const dialogRef = this.dialog.open(WaitDialogComponent, {
        data: { caption: 'Saving...' },
        panelClass: this.className,
        disableClose: true
      });
      this.organizationMaintainenceService.updateDoc(this.selectedOrg, payload).subscribe(res => {
        ////console.log('addzip', res);
        dialogRef.close();
        this.isDocUploaded = true;
        if (!res.Action) {

          this.organizationDetails.DocumentsTab.ORG_DOCS.forEach((obj) => {
            if (obj.SYSTEMIMAGES_ID === doc.SYSTEMIMAGES_ID) obj = final;
          });
          this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
          this.snackBar.open('Success', 'Ok', {
            duration: 2000,
            verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
            horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
            panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
          });
          this.fileName = '';
          this.extractedFileData = '';
        } else {
          Swal.fire({
            text: res.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
        this.closeDocUpdate();
      });
    }
  }

  closeDocUpdate() {
    if (this.isDocUploaded) {
      const dialogRef = this.dialog.open(WaitDialogComponent, {
        data: { caption: 'Loading...' },
        panelClass: this.className,
        disableClose: true
      });
      
      this.organizationMaintainenceService.getOrganizationDocuments(this.selectedOrg).subscribe(data => {
        if (data) {
          this.organizationDetails = {
            ...this.organizationDetails,
            DocumentsTab: data.DocumentsTab
          };
          this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
          this.isDocUploaded = false;
          dialogRef.close();
        }
      });
    }
    this.docType = false;
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  onUploadClicked(event) {
    this.fileName = event[0].name;
    //console.log('event', event)
  }

  onSelectedFilesChanged(event) {
    this.fileName = event[0].name;
    this.formDocGroup.patchValue({
      "IMAGEFILENAME": event[0].name
    });

    this.getBase64(event[0]).then(
      (data: string) => {
        this.extractedFileData = data.split(',');
    
        // const mimeType = this.extractedFileData[0];
        
        // if (mimeType.startsWith('data:image/')) {
        //   this.fileName = event[0].name;
        //   this.formDocGroup.patchValue({
        //   "IMAGEFILENAME": event[0].name
        //   });
        // } else {
        //   Swal.fire({
        //     text: 'Invalid file.Please upload image filetypes',
        //     icon: 'error',
        //     confirmButtonText: 'OK',
        //   })
        // }
      }
    );
  }

  onZipUploadClicked(event) {
    ////console.log('event jj', event[0])
    this.fileName = event[0].name;
    //const base64 = this.getBase64(event[0])
    
    this.getBase64(event[0]).then(
      (data: string) => {
        ////console.log('vadsafdsaf', data.split(','))
        this.extractedFileData = data.split(',')
        if (this.checkFileExt(this.extractedFileData[0]) == 'csv') {
          const temp = window.atob(this.extractedFileData[1])
          const arr = temp.split('\n')
          let resultArray = [];
          arr.pop();
          arr.splice(0, 1)
          ////console.log('zip item', this.addZip);

          resultArray = arr.filter(item => {
            const trimmedItem = item.trim();
            return !this.organizationDetails.ZipCodesTab.includes(trimmedItem) &&
            trimmedItem.length >= 5 &&
            !isNaN(Number(trimmedItem));
          });

          resultArray = resultArray.map(a => a.replace(/\r$/, ''));

          if (resultArray?.length > 0) {
          const dialogRef = this.dialog.open(WaitDialogComponent, {data: {caption: 'Importing...'},panelClass:this.className, disableClose: true});
          this.organizationMaintainenceService.saveZip(this.selectedOrg, resultArray).subscribe(res => {
            ////console.log('addzip', res);
            dialogRef.close();
            if (!res.Action) {
              this.organizationDetails.ZipCodesTab = [...this.organizationDetails.ZipCodesTab, ...resultArray];
              this.addZip = '';
              this.snackBar.open('Success', 'Ok', {
                duration: 2000,
                verticalPosition: 'top', // Allowed values are  'top' | 'bottom'
                horizontalPosition: 'center', // Allowed values are 'start' | 'center' | 'end' | 'left' | 'right'
                panelClass: ['mat-snack-bar-container', 'mat-snack-bar-action']
              });
              this.extractedFileData = '';
              this.fileName = '';
            } else {
              Swal.fire({
                text: res.Message,
                icon: 'error',
                confirmButtonText: 'OK',
              })
            }

          });
        }
        } else {
          Swal.fire({
            text: 'Invalid file.Please upload csv filetype',
            icon: 'error',
            confirmButtonText: 'OK',
          })
        }
      }
    );
  }

  onZipSelectedFilesChanged(event) {
    // //console.log('event jj', event[0])

    // //const base64 = this.getBase64(event[0])
    // this.getBase64(event[0]).then(
    //   (data: string) => {
    //     //console.log('vadsafdsaf', data.split(','))
    //     this.extractedFileData = data.split(',')
    //   }
    // );
    ////console.log('event base64', result['__zone_symbol__value'])
  }


  onSelectAll(e: any): void {
    for (let i = 0; i < this.organizationDetails.WorkorderTypesTab.length; i++) {
      const item = this.organizationDetails.WorkorderTypesTab[i];
      item.SELECTED = e;
    }
  }

  onSelectAllServiceTypes(e: any): void {
    for (let i = 0; i < this.organizationDetails.ServiceTypesTab.length; i++) {
      const item = this.organizationDetails.ServiceTypesTab[i];
      item.SELECTED = e;
    }
  }


  handleClick(org: OrganizationSearch) {
    //console.log('dblclik', org);
    if (org.ORGANIZATION_CD) {
      
      this.orgType = false;
      this.selectedOrg = org.ORGANIZATION_CD;
      this.organizationMaintainenceService.getSelectedOrganizationDetails(this.selectedOrg).subscribe(res => {
        console.log('details---', res)
        this.isOrgSelected = false;
        this.organizationDetails = res
        const { UsersTab: { OrganizationContractors = [], Contractors = [] } } = this.organizationDetails || {};
        const { CLASSIFICATIONS = [], TYPES = [], CLASSIFICATION_CD = '', TYPE_CD = '' } = this.organizationDetails.OrganizationTab || {}
        this.typeOpt = TYPES;
        this.classificationOpt = CLASSIFICATIONS;
        this.dataSourceAccreditations.data = this.organizationDetails.AccreditationsTab;
        this.dataSourceQaDetails.data = this.organizationDetails?.QaDetailsTab?.QADetails;
        this.dataSourceQaStats.data = this.organizationDetails?.QaDetailsTab?.QAStats;
        this.dataSourceDocuments.data = this.organizationDetails.DocumentsTab.ORG_DOCS;
        this.documentTypeOpt = this.organizationDetails.DocumentsTab.DOC_TYPES;
        this.formDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)
        this.formCheckDetailedGroup.patchValue(this.organizationDetails.OrganizationTab)
        this.contractors = Contractors;
        this.organizationContractors = OrganizationContractors;
        
        this.programStatusTab = res.ProgramStatusTab;
        this.programStatusTab?.ProgramStatus.forEach(p => {
          p.SelectedStatusCd = p.SelectedStatusCd ? p.SelectedStatusCd : this.programStatusTab?.Values[0]?.Id;
          p.OrientationDate = p.OrientationDate ? format(new Date(p.OrientationDate), 'yyyy-MM-dd\'T\'00:00:00') : null;
        });

        // Initial sync based on current value
        const streetNumCtrl = this.formDetailedGroup.get('AS_WR_STREETNUM')!; 
        this.isPoBox = this.isPoBoxString(streetNumCtrl.value);
        this.applyPoBoxState(this.isPoBox);

        this.qaDetailsTab = res?.QaDetailsTab;

        this.addAccred= false;
        if ( !this.formDetailedGroup.valid || !this.formCheckDetailedGroup.valid ){
          this.isLegacy = true;
        }      
        this.readonlyOrgCD = true;
        this.formDetailedGroup.patchValue({
          'CLASSIFICATION_CD': CLASSIFICATION_CD,
          'TYPE_CD': TYPE_CD
        });
        const classificationControl = this.formDetailedGroup.get('CLASSIFICATION_CD');
        if (!classificationControl?.value) {
         classificationControl.patchValue(this.classificationOpt[0].CLASSIFICATION_CD);
        }
      }, err => {
        this.isOrgSelected = true;
        Swal.fire({
          text: err,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      });
    } else {
      this.isOrgSelected = true;
      Swal.fire({
        text: "No organization code for the selected",
        icon: 'warning',
        confirmButtonText: 'OK',
      })
    }
  }
  
dateLessThanValidator(startDate: string, endDate: string): ValidatorFn {
   return (control: AbstractControl): { [key: string]: any } | null => {
   const start = control.get(startDate)?.value;
   const end = control.get(endDate)?.value;
  
   if (start && end && new Date(start) >= new Date(end)) {
     return { 'dateInvalid': true };
   }
   return null;
    };
  }

percentageValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;

    if (value === null || value === undefined || value === '') {
       return null;
    }

   const num = parseFloat(value);

   if (!isNaN(num) && num >= 0 && num <= 100) {
     return null;
   }

   return { percentageInvalid: true };
   };
}

  

}
